import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Routes } from '@/router';

@Component({
  name: 'CmgPasswordResetRequestComplete',
})
export default class CmgPasswordResetRequestComplete extends Vue {
  
  @Prop({ default: '', type: String })
  email!: string;

  onClickDone(): void {
    this.redirectOrGoToSignIn();
  }

  onClickRetry() {
    this.$emit('retry-password-reset');
  }

  private redirectOrGoToSignIn() {
    // If there is a return URL, then follow it. Otherwise
    // route to order home.
    const url = this.$router.currentRoute.query.returnUrl;

    if (url) {
      window.location.href = url.toString();
    } else if(this.$router.currentRoute.name == Routes.PasswordResetRequestPage) {
      this.$router.push({name: Routes.SignIn});
    } else if(this.$router.currentRoute.name == Routes.VendorPasswordResetRequestPage) {
      this.$router.push({name: Routes.VendorSignIn});
    } else {
      this.$services.ui.setModalVisibility('signIn', false);
    }
  }
}
